<template>
  <div>
    <el-select v-model="localValue" filterable placeholder="请选择" @change="change">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    </el-select>
  </div>
</template>

<script>
  import {http_post} from '@/api/api'

  export default {
    props: {
      value: {
        type: null,
        default: null
      },
      api: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        localValue: null,
        options: []
      }
    },
    watch: {
      localValue: {
        handler(newVal) {
          if (!this.isEqual(newVal, this.value)) {
            this.$emit('input', _.cloneDeep(newVal)) // 值变化时通知父级
          }
        },
        deep: true
      }
    },
    created() {
      this.localValue = JSON.parse(JSON.stringify(this.value))
      http_post(this.api, {}).then(res => {
        this.options = res.data
      })
    },
    methods: {
      isEqual(a, b) {
        // 智能值比对（处理所有数据类型）
        if (typeof a !== typeof b) return false
        if (typeof a === 'object' && a !== null && b !== null) {
          // 处理引用类型
          return _.isEqual(a, b) // 使用 lodash 深度比对
        }
        return a === b // 基本类型直接比对
      },
      change() {
        this.$emit('change', true)
      }
    }
  }
</script>

<style lang="scss" scoped></style>
